const MiscellaneousActionTypes = {
    FETCH_TEST_USER_EMAILS_START: "FETCH_TEST_USER_EMAILS_START",
    FETCH_TEST_USER_EMAILS_SUCCESS: "FETCH_TEST_USER_EMAILS_SUCCESS",
    FETCH_TEST_USER_EMAILS_FAILURE: "FETCH_TEST_USER_EMAILS_FAILURE",
  };
  
  export default MiscellaneousActionTypes;
  